import ManagerRepository from '../application/ports/ManagerRepository';
import { Manager } from '../domain/Manager';
import { resolveCurrentManager } from './mappers/managerMapper';

class ReduxManagerRepository extends ManagerRepository {
  constructor(private readonly getState: () => unknown) {
    super();
  }

  getCurrentManager(): Manager | null {
    const state = this.getState() as Record<string, any>;
    const mentor = state?.mentor?.get?.('data') ?? state?.mentor?.data;
    const user = state?.user?.get?.('data') ?? state?.user?.data;
    const managerProfile = user?.get?.('manager') ?? user?.manager;
    return resolveCurrentManager(mentor, managerProfile);
  }
}

export default ReduxManagerRepository;
